// JsFromRoutes CacheKey d37b3ba0be7c0fc0517ab60ee110d479
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@corp/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/gift_tags/search'),
  allTags: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/gift_tags/all_tags'),
  merge: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/gift_tags/merge'),
  typeaheadSelect: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/gift_tags/typeahead_select'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/gift_tags'),
  create: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/gift_tags'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/consumer/gift_tags/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/admin/consumer/gift_tags/:id'),
}
